import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './components/application/App';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import {store} from './store/store';
import {ToastProvider} from './components/common/Toast/ToastContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <BrowserRouter>
                <ToastProvider>
                    <App/>
                </ToastProvider>
            </BrowserRouter>
        </Provider>
    </React.StrictMode>,
);
